var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 16L15 19.5C15 19.7761 15.2239 20 15.5 20C15.7761 20 16 19.7761 16 19.5L16 16H19.5C19.7761 16 20 15.7761 20 15.5C20 15.2239 19.7761 15 19.5 15H16L16 12.75V11.5C16 11.2239 15.7761 11 15.5 11C15.2239 11 15 11.2239 15 11.5L15 15L11.5 15C11.2239 15 11 15.2239 11 15.5C11 15.7761 11.2239 16 11.5 16L15 16Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ad57de03ec285b78a7bf30368aefc080.svg";
export { ForwardRef as ReactComponent };